
// Import application modules.
import { ApiClient } from "./apiClient.js";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

export var apiClient = new ApiClient();
